<template>
  <div class="mx-auto md:w-2/3 w-full p-8">
    <h1 class="font-bold text-4xl">Update your password</h1>

    <form :action="passwordPath" method="post">
      <input type="hidden" name="_method" value="put" />
      <input type="hidden" name="authenticity_token" :value="csrfToken" />

      <div class="my-5">
        <input
          type="password"
          name="password"
          required
          autocomplete="new-password"
          placeholder="Enter new password"
          maxlength="72"
          class="block shadow-sm rounded-md border border-gray-400 focus:outline-solid focus:outline-blue-600 px-3 py-2 mt-2 w-full"
        />
      </div>

      <div class="my-5">
        <input
          type="password"
          name="password_confirmation"
          required
          autocomplete="new-password"
          placeholder="Repeat new password"
          maxlength="72"
          class="block shadow-sm rounded-md border border-gray-400 focus:outline-solid focus:outline-blue-600 px-3 py-2 mt-2 w-full"
        />
      </div>

      <div class="inline">
        <button type="submit" class="w-full sm:w-auto text-center rounded-md px-3.5 py-2.5 bg-blue-600 hover:bg-blue-500 text-white inline-block font-medium cursor-pointer">Save</button>
      </div>
    </form>
  </div>
</template>

<script setup>
defineProps({
  csrfToken: { type: String, required: true },
  passwordPath: { type: String, required: true },
});
</script>
